
import Accordion from './Accordion';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';



function Systempune() {



  const cardData =
  {
    keyword: 'Thermal Warming System for Patients in Pune',
    heading: 'Pharmacle Health Care Private Limited: Thermal Warming System for Patients in Pune',
    headingDescription: 'Pharmacle Health Care Private Limited provides high-quality Thermal Warming System for Patients in Pune, ensuring effective temperature management during surgeries and critical care. Our advanced thermal warming systems help prevent hypothermia by delivering consistent and controlled heat, enhancing patient safety and recovery. Widely used in hospitals and healthcare facilities, our thermal warming systems are reliable, easy to use, and designed with cutting-edge technology. Choose Pharmacle Health Care for the best thermal warming solutions in Pune to improve patient care and clinical outcomes.',

    top: 'Pharmacle Health Care Private Limited – Leading Provider of Forced Air-Warming Systems & Blankets',


"topPlaces": [
  {
    "title": "Best Thermal Warming System for Patients in Pune – Advanced Medical Solutions",
    "description": "Pharmacle Health Care offers advanced thermal warming systems in Pune, engineered to regulate patient body temperature with precision. These systems prevent hypothermia during surgeries, ICU stays, and recovery, ensuring safer medical procedures and improved outcomes. Hospitals and clinics trust our solutions for effective thermal support. With durable design and advanced controls, they enhance both patient safety and staff efficiency."
  },
  {
    "title": "Buy Thermal Warming System for Patients in Pune – Effective & Reliable",
    "description": "Our state-of-the-art thermal warming systems provide reliable temperature management across surgical theaters, recovery wards, and critical care units in Pune. Pharmacle Health Care ensures that every device offers efficiency, patient comfort, and clinical safety. Designed with user-friendly interfaces, our systems simplify patient warming for healthcare professionals. Ideal for both large hospitals and smaller specialty clinics seeking dependable thermal care."
  },
  {
    "title": "High-Performance Thermal Warming System for Patients in Pune",
    "description": "Pharmacle Health Care supplies high-performance thermal warming devices in Pune that deliver precise heat distribution to maintain normothermia. These systems are essential in reducing complications related to hypothermia and enhancing patient recovery rates. Trusted by top healthcare institutions, our warming systems integrate seamlessly with modern medical workflows. Built with advanced sensors, they provide consistent performance in demanding clinical environments."
  },
  {
    "title": "Top-Quality Thermal Warming System for Patients in Pune – Safe & Efficient",
    "description": "Our thermal warming systems are designed for superior safety and efficiency, ensuring uniform temperature regulation for patients in Pune hospitals. Pharmacle Health Care’s solutions reduce risks of hypothermia and post-surgical complications while improving comfort. They are built to meet international medical standards, making them highly reliable. With strong local support, we provide hospitals with equipment that balances innovation and affordability."
  },
  {
    "title": "Affordable & Trusted Thermal Warming System for Patients in Pune",
    "description": "Pharmacle Health Care delivers cost-effective thermal warming systems in Pune without compromising quality. Perfect for hospitals, clinics, and nursing facilities, these systems ensure accurate temperature control during patient treatment. Designed to lower risks of perioperative hypothermia, they improve patient comfort and safety. As a trusted medical supplier, we make advanced warming solutions accessible to healthcare providers at competitive prices."
  },
  {
    "title": "Leading Supplier of Thermal Warming System for Patients in Pune",
    "description": "Recognized as a leading supplier, Pharmacle Health Care provides advanced thermal warming systems trusted by Pune’s hospitals and critical care centers. Our solutions help maintain consistent body temperature during surgery, trauma, and ICU treatment. With proven reliability and strong after-sales support, our devices are the first choice for healthcare institutions. They are designed for long-term performance, efficiency, and patient-centered care."
  },
  {
    "title": "Efficient Thermal Warming System for Patients in Pune – ICU & Surgical Use",
    "description": "Our thermal warming systems are essential in intensive care and surgical applications, ensuring stable patient temperatures during critical treatment. Pharmacle Health Care provides efficient solutions that adapt to various clinical needs in Pune hospitals. By supporting normothermia, our devices minimize complications and enhance patient outcomes. Built with advanced heating technology, they deliver quick response and consistent results in high-demand scenarios."
  },
  {
    "title": "Pediatric & Adult Thermal Warming System for Patients in Pune",
    "description": "Pharmacle Health Care offers thermal warming systems suitable for patients of all ages, from neonatal to adult care. In Pune’s NICUs and pediatric wards, our systems provide gentle, regulated warmth to protect newborns and infants. For adults, they ensure precise thermal management during surgery and recovery. These devices are designed to meet diverse clinical requirements, delivering safe and effective patient warming solutions."
  },
  {
    "title": "Advanced Thermal Warming System for Patients in Pune – Ideal for Hospitals",
    "description": "Designed with advanced thermal regulation features, our warming systems are ideal for hospitals and surgical centers in Pune. Pharmacle Health Care ensures consistent body temperature management, critical for trauma patients, ICU treatments, and post-operative care. These systems combine innovation with ease of use, providing reliability for medical staff. Widely adopted by healthcare providers, they ensure better safety and recovery outcomes."
  },
  {
    "title": "Buy High-Quality Thermal Warming System for Patients in Pune",
    "description": "Pharmacle Health Care supplies premium thermal warming solutions that guarantee patient safety and comfort across Pune’s hospitals and clinics. Our high-quality devices reduce hypothermia risks during surgery and accelerate recovery times. Built with durable components and intelligent controls, they deliver precise heating for clinical excellence. Trusted by leading institutions, our systems are a smart investment for better healthcare outcomes."
  }
],

      "services": [
        {
            "name": "Thermal Warming System Pune",
            "description": "Pharmacle Health Care offers thermal warming systems in Pune, designed to regulate body temperature during medical procedures. These systems are highly effective in preventing hypothermia and ensuring a safe and comfortable environment for patients during surgeries and recovery."
        },
        {
            "name": "Pune Warming Systems for Patients",
            "description": "We provide warming systems for patients in Pune, designed to maintain an optimal body temperature during medical treatments. These systems help prevent temperature-related complications and ensure a safe and comfortable environment for patients throughout surgeries and recovery."
        },
        {
            "name": "Patient Warming Devices Pune",
            "description": "Pharmacle Health Care offers patient warming devices in Pune, designed to regulate and maintain body temperature during medical procedures. These devices ensure patient safety and comfort by preventing hypothermia and other temperature-related complications during surgeries and recovery."
        },
        {
            "name": "Forced Air Warming System Pune",
            "description": "We provide forced air warming systems in Pune, designed to circulate warm air and maintain body temperature during medical procedures. These systems are highly effective in preventing hypothermia and ensuring patient safety and comfort during surgeries and recovery."
        },
        {
            "name": "Pune Medical Temperature Management Systems",
            "description": "Pharmacle Health Care provides medical temperature management systems in Pune, designed to regulate body temperature during surgeries and medical procedures. These systems help prevent hypothermia and ensure a safe, comfortable environment for patients throughout treatment."
        }
    ],
    "tableData": [
        ["- Thermal Warming System Pune", "- Pune Warming Systems for Patients"],
        ["- Patient Warming Devices Pune", "- Forced Air Warming System Pune"],
        ["- Pune Medical Temperature Management Systems"]
    ],

"whychoose": [
    {
        "WhyChooseheading": "Advanced and Reliable Warming Technology",
        "WhyChoosedescription": "Pharmacle Health Care Private Limited offers advanced thermal warming systems for patients in Pune, designed to provide precise temperature control during medical treatments. Our technology ensures reliable performance to prevent hypothermia, enhancing patient safety in hospitals and clinics across the Pune region."
    },
    {
        "WhyChooseheading": "Comprehensive Patient Warming Solutions",
        "WhyChoosedescription": "We provide a wide range of thermal warming systems for patients in Pune, including warming devices, blankets, and temperature control systems. Our solutions are tailored for both surgical procedures and critical care, ensuring your patients remain comfortable and safe throughout their treatment."
    },
    {
        "WhyChooseheading": "High-Quality, Durable Equipment",
        "WhyChoosedescription": "Our thermal warming systems for patients are manufactured to the highest quality standards, ensuring durability and long-lasting performance. Regularly tested and maintained, our systems provide optimal reliability for continuous use in medical settings throughout Pune."
    },
    {
        "WhyChooseheading": "Safe and Comfortable for Patients",
        "WhyChoosedescription": "Patient safety and comfort are our top priorities. Our thermal warming systems for patients provide controlled, gentle warmth to prevent temperature-related complications during surgeries and procedures, ensuring that patients in Pune are always in the safest hands."
    },
    {
        "WhyChooseheading": "Flexible Solutions for Healthcare Providers",
        "WhyChoosedescription": "Our thermal warming systems for patients in Pune are adaptable to various healthcare settings, including hospitals, clinics, and emergency rooms. We work closely with healthcare providers to ensure our systems meet their specific needs, improving overall patient care."
    },
    {
        "WhyChooseheading": "Easy Integration with Existing Systems",
        "WhyChoosedescription": "Pharmacle Health Care’s thermal warming systems for patients are designed for seamless integration with existing medical systems in Pune. Our products can be quickly implemented, ensuring smooth and efficient operation without disrupting ongoing medical procedures."
    },
    {
        "WhyChooseheading": "Expert Consultation and Support",
        "WhyChoosedescription": "We provide expert consultation services in Pune to help healthcare facilities select the right thermal warming systems for patients. Our team also offers ongoing support and maintenance to ensure your equipment operates efficiently and reliably."
    },
    {
        "WhyChooseheading": "Commitment to Patient Safety and Comfort",
        "WhyChoosedescription": "At Pharmacle Health Care Private Limited, patient safety and comfort are at the core of everything we do. Our thermal warming systems for patients are designed to prevent temperature-related issues during critical medical procedures, ensuring that every patient in Pune receives the highest standard of care."
    }
]






















  }

  const faqData = [
    { question: "What is a Forced Air Warming System?", answer: "A Forced Air Warming System is a medical device used to regulate and maintain a patient’s body temperature during surgeries and medical procedures. It works by blowing warm air through a special warming blanket or pad placed over the patient." },
    { question: "How does the Forced Air Warming System work?", answer: "The system works by using a blower to circulate warm air through a blanket or pad that is placed on the patient’s body. This helps prevent hypothermia by maintaining the patient’s body temperature within a safe and comfortable range." },
    { question: "Is the Thermal Warming System for Patients available in Pune?", answer: "Yes, Pharmacle Health Care Private Limited offers Thermal Warming Systems for Patients in Pune, providing hospitals and healthcare facilities with an effective solution to maintain patient body temperature during medical treatments." },
    { question: "What are the benefits of using a Forced Air Warming System?", answer: "The benefits include preventing hypothermia, reducing surgical complications, improving patient comfort, speeding up recovery times, and ensuring a stable body temperature throughout medical procedures." },
    { question: "How long can the Forced Air Warming System maintain the patient’s temperature?", answer: "The Forced Air Warming System can maintain the patient’s body temperature for the entire duration of the medical procedure, ensuring consistent warmth and temperature control." },
    { question: "Is the Forced Air Warming System easy to use?", answer: "Yes, the system is designed to be user-friendly, with simple controls that allow healthcare professionals to adjust the temperature settings quickly and efficiently." },
    { question: "Can the Forced Air Warming System be used for all types of surgeries?", answer: "Yes, the Forced Air Warming System is versatile and can be used in a wide range of surgeries and medical procedures, particularly those where maintaining normothermia is essential for patient safety." },
    { question: "Is the Forced Air Warming System safe for all patients?", answer: "Yes, the system is generally safe for most patients. However, it should always be used under the supervision of trained healthcare professionals to ensure proper temperature regulation and avoid overheating or underheating." },
    { question: "How can I purchase a Forced Air Warming System in Pune?", answer: "You can contact Pharmacle Health Care Private Limited directly, and our team will assist you with purchasing and delivering the Forced Air Warming System to your healthcare facility in Pune." },
    { question: "Does Pharmacle Health Care provide support for the Forced Air Warming System?", answer: "Yes, we offer complete support for the Forced Air Warming System, including installation, training for healthcare professionals, and ongoing maintenance to ensure optimal performance." }
  ];
  
  const testimonialsData = [
    {
      text: 'We have been using the Thermal Warming System for Patients from Pharmacle Health Care in our Pune hospital. It has significantly improved our ability to maintain patient temperature during surgeries, ensuring safety and comfort.',
      name: 'Dr. Raghav Deshmukh',
    },
    {
      text: 'The Thermal Warming System for Patients from Pharmacle Health Care has been an essential tool in our Pune clinic. It provides reliable temperature regulation, which is crucial for patient care during medical procedures.',
      name: 'Pune Medical Clinic',
    }
  ];
  
  
  
  
  
  
  
  

  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  























  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 8956322311",
      "+91 8421773700",

    ],
    email: "info@wallabieswarmcares.com"
  };


const Images = [
  {
    place: "/images/keyword/1.jpg",
    text: "Patient Forced Air Warming System in Pune",
    link: "/Patient-Forced-Air-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/2.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi",
  },
  {
    place: "/images/keyword/3.jpg",
    text: "Patient Forced Air Warmer in Mumbai",
    link: "/Patient-Forced-Air-Warmer-in-Mumbai",
  },
  {
    place: "/images/keyword/5.jpg",
    text: "Patient Warming Systems in Chennai",
    link: "/Patient-Warming-Systems-in-Chennai",
  },
  {
    place: "/images/keyword/6.jpg",
    text: "Patient Warmer in Bengaluru",
    link: "/Patient-Warmer-in-Bengaluru",
  },
  {
    place: "/images/keyword/7.jpg",
    text: "Normothermia Equipment in Hyderabad",
    link: "/Normothermia-Equipment-in-Hyderabad",
  },
  {
    place: "/images/keyword/8.jpg",
    text: "Patient Thermoregulation System in Ahmedabad",
    link: "/Patient-Thermoregulation-System-in-Ahmedabad",
  },
  {
    place: "/images/keyword/9.jpg",
    text: "Patient Warming Devices in Kolkata",
    link: "/Patient-Warming-Devices-in-Kolkata",
  },
  {
    place: "/images/keyword/10.jpg",
    text: "Patient Warming Blankets in Jaipur",
    link: "/Patient-Warming-Blankets-in-Jaipur",
  },
  {
    place: "/images/keyword/12.jpg",
    text: "Patient Forced Air Warming System in Surat",
    link: "/Patient-Forced-Air-Warming-System-in-Surat",
  },
  {
    place: "/images/keyword/13.jpg",
    text: "Forced Air Warming Blankets in Coimbatore",
    link: "/Forced-Air-Warming-Blankets-in-Coimbatore",
  },
  {
    place: "/images/keyword/14.jpg",
    text: "Patient Warming Blankets in Lucknow",
    link: "/Patient-Warming-Blankets-in-Lucknow",
  },
  {
    place: "/images/keyword/15.jpg",
    text: "Patient Forced Air Warmer in Chandigarh",
    link: "/Patient-Forced-Air-Warmer-in-Chandigarh",
  },
  {
    place: "/images/keyword/17.jpg",
    text: "Thermoregulation Systems in Indore",
    link: "/Thermoregulation-Systems-in-Indore",
  },
  {
    place: "/images/keyword/18.jpg",
    text: "Patient Warming Systems in Patna",
    link: "/Patient-Warming-Systems-in-Patna",
  },
  {
    place: "/images/keyword/19.jpg",
    text: "Patient Forced Air Warming System in Hyderabad",
    link: "/Patient-Forced-Air-Warming-System-in-Hyderabad",
  },
  {
    place: "/images/keyword/20.jpg",
    text: "Patient Forced Air Warming Blankets in Delhi NCR",
    link: "/Patient-Forced-Air-Warming-Blankets-in-Delhi-NCR",
  },
  {
    place: "/images/keyword/21.jpg",
    text: "Forced Air Warming System in Noida",
    link: "/Forced-Air-Warming-System-in-Noida",
  },
  {
    place: "/images/keyword/22.jpg",
    text: "Patient Warming Devices in Bhopal",
    link: "/Patient-Warming-Devices-in-Bhopal",
  },
  {
    place: "/images/keyword/23.jpg",
    text: "Patient Warming Blankets in Kochi",
    link: "/Patient-Warming-Blankets-in-Kochi",
  },
  {
    place: "/images/keyword/24.jpg",
    text: "Patient Warming System in Pune",
    link: "/Patient-Warming-System-in-Pune",
  },
  {
    place: "/images/keyword/25.jpg",
    text: "Forced Air Warming Blankets in Bengaluru",
    link: "/Forced-Air-Warming-Blankets-in-Bengaluru",
  },
  {
    place: "/images/keyword/26.jpg",
    text: "Patient Warming Devices in Chennai",
    link: "/Patient-Warming-Devices-in-Chennai",
  },
  {
    place: "/images/keyword/27.jpg",
    text: "Patient Thermoregulation System in Surat",
    link: "/Patient-Thermoregulation-System-in-Surat",
  },
];


  const images = [
    { src: "/images/keyword/1.jpg", alt: "Image 1" },
    { src: "/images/keyword/5.jpg", alt: "Image 1" },
    { src: "/images/keyword/2.jpg", alt: "Image 1" },
    { src: "/images/keyword/18.jpg", alt: "Image 1" },
    { src: "/images/keyword/4.jpg", alt: "Image 1" },
    { src: "/images/keyword/7.jpg", alt: "Image 1" },
    { src: "/images/keyword/8.jpg", alt: "Image 1" },
    { src: "/images/keyword/19.jpg", alt: "Image 1" },
    { src: "/images/keyword/6.jpg", alt: "Image 1" },

  ];


  const jsonData = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "Thermal Warming System for Patients in Pune",
    "description": "Explore advanced Thermal Warming Systems for patients in Pune, including forced air warming systems and medical temperature management solutions. Ensure patient comfort and safety during medical procedures.",
    "aggregateRating": {
      "@type": "AggregateRating",
      "bestRating": "5",
      "worstRating": "1",
      "ratingValue": "4.9",
      "ratingCount": "1515"
    }
  };
  

  


  return (
    <div>
  <Helmet>
    <title>Thermal Warming System for Patients in Pune | Contact: +91 8956322311</title>
    <meta
      name="description"
      content="Explore Thermal Warming Systems for patients in Pune, including forced air warming systems and medical temperature management. Contact us at +91 8956322311."
    />
    <meta
      name="keywords"
      content="Thermal Warming System Pune, Pune Warming Systems for Patients, Patient Warming Devices Pune, Forced Air Warming System Pune, Pune Medical Temperature Management Systems"
    />
    <script type="application/ld+json">
      {JSON.stringify(jsonData)}
    </script>
  </Helmet>
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <h2>{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>



      <section>
        <div className="container-fluid" >
          <div className="row container-fluid pt-5">
            <div className="col-12 col-md-7 ">
              <img src='/images/keyword/.jpg' alt='img' />
              <h3 className="py-1 pt-4"
                style={{
                  color: '#1A76D1', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3>

              <p className='fw-bold lead text-dark'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3 text-dark'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>

              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            

              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>
              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for  Pharmacle Health Care Private Limited</h3>
              
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
            
                <TestimonialKeyword testimonials={testimonialsData} />


              </div>

              <div className='pb-5'>

                <div className="contact-box Borderr ">
                  <h3>{contactData.heading}</h3>
                  <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                  <div className="contact-details ">
                    <ul>
                      {contactData.contactNumbers.map((number, index) => (
                        <li key={index}>
                          <a href={`tel:${number}`} className="contact-link fw-bold d-inline "><p className='d-inline'><strong className='darkcolor d-inline'>Mobile No:</strong></p>
                            {number}
                          </a>
                        </li>
                      ))}
                    </ul>
                    <p><strong className='darkcolor'>Email Id: </strong>
                      <a href={`mailto:${contactData.email}`} className="contact-link">
                        {contactData.email}
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-12 col-md-4'>
              {Images.map((e) => {
                return (
                  <div className="box1">
                    <a href={e.link} className="d-flex justify-content-around align-items-center">
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        <a href={e.link} className='px-3'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })}



              <div className="gallery-container">
                <h2 className="gallery-title darkcolor">Our Gallery</h2>
                <div className="row">
                  {images.map((image, index) => (
                    <div className="gallery-item col-md-4" key={index}>
                      <img
                        src={image.src}
                        alt={image.alt}
                        className="gallery-image"

                      />
                    </div>
                  ))}

                </div>
              </div>

              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px solid #1A76D1',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3  fw-bold text-bluee text-center">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3 rounded">
                    <div className="Small_border rounded  text-center  " style={{ backgroundColor: '#1A76D1' }}>
                      <div>
                        <h4 className=" lead fw-semibold whitt ">Phone Numbers</h4>
                      </div>

                      <div className=''>
                        <a href="tel:+918956322311" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8956322311
                        </a>
                        <a href="tel:+918421773700" className="d-block  text-white">
                          <i className="fas fa-phone darkcolorrr colored me-2"></i>+91 8421773700
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:info@wallabieswarmcares.com" className=" text-white d-block">
                          <i className="fas fa-envelope darkcolorrr"></i> info@wallabieswarmcares.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">

                      <div className='rounded ' style={{ backgroundColor: '#1A76D1' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className=" text-white ">
                          <i className="fas fa-map-marker-alt darkcolorrr"></i>  Pharmacle Health Care Private Limited <br />
                          Gat No. 1251/2/3/1252 Plot No. 28, Block Sector, Weikfield Industrial Estate, Pune - Nagar Road, Sanaswadi, Pune, Maharashtra, 412208


                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Systempune;